import { useUploadProductCurrencyExcelIn } from "../hooks/useUploadProductCurrencyExcelIn";
import { ProductInListElementType, ProductInListMapType, ProductInSearchParamType } from "../interface";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import { PaginationMain } from "../../../../../components/common/pagination/PaginationMain";
import FileUploadNoText from "../../../../../components/common/fileUpload/fileUploadNoText/FileUploadNoText";
import { useExportProductExcelIn } from "../hooks/useExportProductExcelIn";
import { Tooltip } from "react-tooltip";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";

interface PropsType {
    product: ProductInListMapType,
    searchParam: ProductInSearchParamType
}

export default function List({ product, searchParam }: PropsType) {
    const { goToNavigation } = useGoToNavigation();

    const checkEllipsis = (element: HTMLElement) =>
        element.scrollWidth > element.clientWidth;

    const { mutate: mutateUploadProductCurrencyExcelIn } = useUploadProductCurrencyExcelIn()
    const { mutate: mutateExportProductExcelIn } = useExportProductExcelIn()

    const btnExportExcel = () => {
        mutateExportProductExcelIn({ ...searchParam, pageNo: 1, limit: 1000000 })
    }

    const btnUploadProductCurrencyExcelIn = (file: File[]) => {
        const fd = new FormData()
        file.map(el => fd.append("excelFile", el))

        mutateUploadProductCurrencyExcelIn(fd)
    }
    /* 내부수정: 새창으로 열리기
    const clickRow = (el: ProductInListElementType) => {
        el.newErpProductid && goToNavigation(`product/detail/${el.newErpProductid}`, {}, false)
    } */
    const clickRow = (el: ProductInListElementType, e: React.MouseEvent) => {
        if (!el.newErpProductid) return;
        const url = `product/detail/${el.newErpProductid}`;
        // 휠 클릭
        if (e.button === 1) {
            goToNavigation(url, {}, false, { newTab: true });
            return;
        }
        // ctrl / cmd
        if (e.ctrlKey || e.metaKey) {
            goToNavigation(url, {}, false, { newTab: true });
            return;
        }
        // 일반 클릭
        if (e.button === 0) {
            goToNavigation(url, {}, false);
        }
    };

    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">제품 목록(<span>{product.totalCount}</span>건)</h6>
            <div className="table_toolbar">
                <button className="btn btn-dark w-150px px-0" onClick={btnExportExcel}><img
                    src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기
                </button>
                <FileUploadNoText
                    addFileCallback={(file: File[]) => btnUploadProductCurrencyExcelIn(file)}
                    customRenderer={(onClick: any, disabled: any) =>
                        <button className="btn btn-outline-dark w-150px px-0"
                            onClick={onClick}
                            disabled={disabled}>
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt="" />엑셀 가져오기
                        </button>}
                    accept={".xlsx, .xls"}
                />
            </div>
        </div>
        {/* 내부수정: table_scroll 삭제 */}                
        <table className="table table-bordered my_table" style={{ tableLayout: "fixed", width: "100%" }}>
            <thead>
                <tr>
                    <th rowSpan={2} style={{ width: "110px" }}>벤더</th>
                    <th rowSpan={2} style={{ width: "110px" }}>카테고리</th>
                    <th rowSpan={2} style={{ width: "120px" }}>제품군</th>
                    <th rowSpan={2}
                        style={{ width: "488px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>품목
                    </th>
                    <th rowSpan={2}
                        style={{ width: "260px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>규격
                    </th>
                    {/*<th rowSpan={2} style={{width: "140px"}}>대분류</th>*/}
                    {/*<th rowSpan={2} style={{width: "140px"}}>중분류</th>*/}
                    {/*<th rowSpan={2} style={{width: "78px"}}>환종</th>*/}
                    <th colSpan={5} style={{ width: "420px" }}>가격</th>
                </tr>
                <tr>
                    <th style={{ width: "85px" }}>Level A</th>
                    <th style={{ width: "85px" }}>Level B</th>
                    <th style={{ width: "85px" }}>Level C</th>
                    <th style={{ width: "85px" }}>Level D</th>
                    <th style={{ width: "85px" }}>Level E</th>
                </tr>
            </thead>
            <tbody>
                {product.productList.length !== 0 ? product.productList.map((el: ProductInListElementType, idx: number) => (
                    <tr className="clickable" onMouseDown={(e) => clickRow(el, e)}> 
                        <td className="text-center">{el.vendor}</td>
                        <td className="text-center">{el.category}</td>
                        <td className="text-center">{el.productRange}</td>
                        <td
                            className="text-center"
                            data-tooltip-id="tooltip-std"
                            data-tooltip-content={el.new_txt_nm_item}
                            style={{
                                width: "240px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            }}
                        >
                            {el.new_txt_nm_item}
                        </td>
                        <td
                            className="text-center"
                            data-tooltip-id="tooltip-std"
                            data-tooltip-content={el.new_txt_stnd_item}
                            style={{
                                width: "240px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            }}
                        >
                            {el.new_txt_stnd_item}
                        </td>
                        {/*<td className="text-center">{el.majorCategory}</td>*/}
                        {/*<td className="text-center">{el.subCategory}</td>*/}
                        {/*<td className="text-center">{el.currency}</td>*/}
                        <td className="text-center"><DisplayNumber value={el.levelA} /></td>
                        <td className="text-center"><DisplayNumber value={el.levelB} /></td>
                        <td className="text-center"><DisplayNumber value={el.levelC} /></td>
                        <td className="text-center"><DisplayNumber value={el.levelD} /></td>
                        <td className="text-center"><DisplayNumber value={el.levelE} /></td>
                    </tr>
                )) : <EmptyTableRow colSpan={12} />}
            </tbody>

            <Tooltip id="tooltip-std" className="custom-tooltip" />
        </table>
        

        <PaginationMain totalCount={product.totalCount ?? 0} />
    </div>
}